<template>
	<v-sheet elevation="0">
		<v-app-bar tag="div" dense class="overflow-x-auto" color="white">
			<v-btn text @click="$router.push({ name: 'daily_report_new' })"> 日報作成</v-btn>
			<v-divider vertical />
			<RequirementNewDialog
				ref="new"
				myPageBtn
				text
				:requirementTypes="requirementTypes"
				:user="$store.getters['auth/authData']"
				@openConfirm="openConfirm"
				@requirement-new-data="setRequirementData($event)"
			/>
			<RequirementConfirm
				ref="confirm"
				:confirmPackage="confirmPackage"
				@finishedCreateNew="finishedCreateNew"
			/>
			<v-divider vertical />
			<MessageNewDialog
				myPageBtn
				:message="message"
				:message_templates="newMessage.message_templates"
				:departments="newMessage.departments"
				:requirement_types="newMessage.requirement_types"
				@message-new-data="setMessageData($event)"
			/>
		</v-app-bar>

		<v-row no-gutters class="mt-2" align="stretch">
			<v-col cols="12" md="4" class="py-2 pa-sm-2">
				<CalendarComponent
					:title="'カレンダー'"
					:height="null"
					:events="[]"
					@click-event="() => {}"
				/>
			</v-col>
			<v-col cols="12" md="8">
				<v-row no-gutters>
					<v-col cols="12" class="py-2 pa-sm-2">
						<TableComponent
							:title="'未読メッセージ'"
							:height="200"
							:items="messages"
							:headers="messageHeaders"
							:noDataText="'未読メッセージはありません。'"
						>
							<template v-slot:header-btn>
								<v-btn @click="$router.push({ name: 'message_index' })" color="white" text
									>一覧ページへ</v-btn
								>
							</template>
							<template v-slot:record="{ item }">
								<tr class="no-click">
									<td>
										{{ item.title }}
									</td>
									<td>
										{{ common.truncate(item.content, 10) }}
									</td>
									<td v-if="item.user && item.user.full_name">
										{{ item.user.full_name }}
									</td>
									<td v-else width="70%">システム</td>
									<td>
										{{ item.created_at | dateFormatter }}
									</td>
								</tr>
							</template>
						</TableComponent>
					</v-col>
					<v-col cols="12" class="py-2 pa-sm-2 grow">
						<TableComponent
							:title="'担当している依頼一覧'"
							:height="null"
							:items="requirements"
							:headers="requirementHeaders"
							:noDataText="'自分宛の依頼はありません。'"
						>
							<template v-slot:header-btn>
								<v-btn
									color="white"
									text
									v-if="$store.getters['auth/authData'].user_departments.length == 1"
									@click="
										$router.push({
											name: 'requirement_index',
											query: {
												department_id: $store.getters['auth/authData'].user_departments[0].id,
											},
										})
									"
								>
									一覧ページへ
								</v-btn>
								<v-menu
									v-else-if="$store.getters['auth/authData'].user_departments.length > 1"
									offset-y
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="white" text v-bind="attrs" v-on="on"> 一覧ページへ </v-btn>
									</template>
									<v-list>
										<v-list-item
											v-for="(department, index) in $store.getters['auth/authData']
												.user_departments"
											:key="index"
											@click="
												$router.push({
													name: 'requirement_index',
													query: { department_id: department.id },
												})
											"
										>
											<v-list-item-title>{{ department.name }}</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</template>
							<template v-slot:record="{ item }">
								<tr class="" @click="openRequirementShow(item.id)">
									<td>
										{{ statusIdsHash[item.status_id] }}
									</td>
									<td>{{ item.requirement_type.name }} {{ item.subtitle }}</td>
									<td>
										{{ item.from_department.name }}
									</td>
									<td>
										{{ item.user.full_name }}
									</td>
									<td>
										{{ item.requirement_date | dateFormatter }}
									</td>
									<td>
										{{ item.deadline | dateFormatter }}
									</td>
								</tr>
							</template>
						</TableComponent>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<RequirementShowDialog ref="show" @reloadIndex="reloadList" />
	</v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"

import CalendarComponent from "./components/CalendarComponent.vue"
import ChartComponent from "./components/ChartComponent.vue"
import TableComponent from "./components/TableComponent.vue"
import MessageNewDialog from "../message/components/MessageNewDialog.vue"
import RequirementNewDialog from "../requirement/components/RequirementNewDialog.vue"
import RequirementConfirm from "../requirement/components/RequirementConfirm.vue"
import RequirementShowDialog from "../requirement/components/RequirementInfoDialog.vue"

export default {
	components: {
		CalendarComponent,
		ChartComponent,
		TableComponent,
		MessageNewDialog,
		RequirementNewDialog,
		RequirementConfirm,
		RequirementShowDialog,
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			if (!time) return
			return moment(time).format("HH:mm")
		},
	},
	data() {
		return {
			id: this.$route.params.id,
			messages: [],
			messageHeaders: [
				{ text: "タイトル", value: "title", width: "200px" },
				{ text: "内容", value: "content", width: "200px" },
				{ text: "送信者", value: "user.full_name", width: "200px" },
				{ text: "受信日時", value: "created_at", width: "200px" },
			],
			requirements: [],
			requirementHeaders: [
				{ width: "100px", text: "状態", value: "status_id" },
				{ width: "200px", text: "依頼の種類", value: "requirement_type_name" },
				{ width: "150px", text: "依頼元部門", value: "from_department_name" },
				{ width: "150px", text: "依頼者", value: "user_name" },
				{ width: "120px", text: "依頼発行日", value: "requirement_date" },
				{ width: "120px", text: "希望納期", value: "deadline" },
			],
			statusIdsHash: null,
			user_departments: this.$store.getters["auth/authData"].user_departments,
			message: {
				title: "",
				content: "",
				image: null,
				fileData: {
					type: "",
					fileName: "",
				},
				matter: "",
				user_name: "",
				selectedDepartmentId: "",
				selectedUser: "",
				selectedMessageTemplateId: "",
				selectedRequirementTypeId: "",
			},
			newMessage: {
				message_templates: [],
				departments: [],
				requirement_types: [],
			},
			common: common,
			confirmPackage: {},
			requirementTypes: [],
		}
	},
	mounted() {
		this.user_departments = this.$store.getters["auth/authData"].user_departments
		authenticate.authenticateUser()
		const headers = authenticate.setHeader()
		const url = `/erp/v1/users/${this.id}/mypages`
		axios
			.get(url, { headers })
			.then((res) => {
				this.messages = res.data.messages
				this.requirements = res.data.requirements
				this.statusIdsHash = res.data.status_ids_hash
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	methods: {
		openRequirementShow(id) {
			this.$refs.show.openDialog(id, 0)
		},
		reloadList() {
			// ダミー
		},
		setMessageData(data) {
			this.newMessage.message_templates = data.message_templates
			this.newMessage.departments = data.departments
			this.newMessage.requirement_types = data.requirement_types
		},
		setRequirementData(data) {
			this.requirementTypes = data.requirement_types
		},
		openConfirm(dataSet) {
			this.confirmPackage = dataSet
			this.$refs.confirm.openDialog()
		},
		finishedCreateNew() {
			this.$refs.new.closeDialog()
		},
	},
	computed: {
		// events() {
		// 		events.push({
		// 			name: this.names[this.rnd(0, this.names.length - 1)],
		// 			start: first,
		// 			end: second,
		// 			color: this.colors[this.rnd(0, this.colors.length - 1)],
		// 			timed: !allDay,
		// 		})
		// 	return events
		// },
	},
}
</script>

<style lang="scss" scoped>
.height-50 {
	height: 50%;
}
tr.no-click {
	&:hover {
		background-color: none;
	}
}
</style>
